import { Component, OnInit, Input, OnChanges, Output, EventEmitter, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { BnLoadingService, EntityOrderedRequestParameters, EntityPagedRequestParameters, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";

import moment from "moment";
import { JanelaRenunciaResponseDto, Renuncia } from 'src/app/model/renuncia.model';
import { RenunciaService } from '../renuncia.service';
import { RenunciaPesquisaComponent } from '../pesquisa/renuncia-pesquisa.component';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { PermissaoService } from 'src/app/shared/permissao.service';

@Component({
    selector: 'app-renuncia-listagem',
    templateUrl: 'renuncia-listagem.component.html',
    styleUrls: ['renuncia-listagem.component.scss'],
    standalone: false
})
export class RenunciaListagemComponent implements OnInit, OnChanges, OnDestroy {

  @Input() renuncias: Renuncia[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public mostrarExportarSolicitacoes: boolean;
  @Input() public ehAgenteFinanceiro: boolean;
  @Input() refresh: any;
  @Input() limpar: any;
  @Output() public exportarLista: EventEmitter<any> = new EventEmitter<any>();
  public dataLimites: string = undefined;
  public podeExcluir: boolean = false;
  private atributosOrdenacao: EntityOrderedRequestParameters;
  public janelaRenuncia: JanelaRenunciaResponseDto;
  private readonly destroy$ = new Subject();
  public perfilAdminTransacional: boolean = false;
  @ViewChild('modalExclusao') modalExclusao: TemplateRef<any>;
  @ViewChild('botoesModalExclusao') botoesModalExclusao: TemplateRef<any>;
  ideRenuncia: number;

  constructor(private renunciaService: RenunciaService,
    private messageService: MessageChannelService,
    private bnLoadingService: BnLoadingService,
    private renunciaPesquisaComponent: RenunciaPesquisaComponent,
    private permissaoService: PermissaoService,
    private modalService: BnModalMessageService
) {
  }

  ngOnInit() {
    this.verificaPodeExcluir();
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .pipe(takeUntil(this.destroy$))
        .subscribe((resp: any) => {
          this.perfilAdminTransacional = resp && resp[ROLE_GESTOR_ENVIO];
          this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];
        });
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  ngOnChanges(changesObj) {
    if (changesObj.refresh) {
      this.buscarRenuncias();
    } else if (changesObj.limpar) {
      this.renuncias = [];
    }
  }

  ngOnDestroy(): void {
      this.destroy$.next(undefined);
      this.destroy$.complete();
  }

  private buscarRenuncias() {
  }

  btnExportarLista() {
    this.exportarLista.emit(null);
  }

  exibeListagem() {
    return (this.renuncias && this.renuncias?.length) && this.renuncias?.length != undefined;
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.renuncias = this.renuncias.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  async excluirRenuncia() {
    if (!this.podeExcluir || !this.ehAgenteFinanceiro) return;
    this.bnLoadingService.bloqueiaTela();
    this.modalService.dismiss('confirmado exclusão de renúncia.');
    try {
      await this.renunciaService.excluirRenuncias(this.ideRenuncia).toPromise();
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Solicitação de Renúncia excluída.'
      })
      this.renunciaPesquisaComponent.limparPesquisa();
    } catch (err) {
      console.log('erro ao excluir renuncia', err);
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

  async verificaPodeExcluir() {
    this.janelaRenuncia = await this.renunciaService.getJanelaAtiva().toPromise();
    let validade = moment().isAfter(this.janelaRenuncia.dataInicioVigencia) && moment().isBefore(this.janelaRenuncia.dataFimVigencia);
    this.podeExcluir = validade;
  }

  abrirModalConfirmarExclusao(ideRenuncia: number) {
    this.ideRenuncia = ideRenuncia;
    const modal = this.modalService.abrir('Confirmação', null, 'md', this.modalExclusao, this.botoesModalExclusao);
    modal.result.finally(() => this.ideRenuncia = null);
  }

  desistirExclusao() {
    this.modalService.dismiss('abortou solicitação de exclusão');
  }

}
